import './App.css';
import Dmain from './Desktop/D_main';
import _ from "lodash";
import React, { Component } from 'react'
import YearList from './Desktop/YearList';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Obhodnoilist from './Desktop/Components/Reports/Obhodnoilist';
import SocFond from './Desktop/Components/Reports/SocFond';
import VoenCom from './Desktop/Components/Reports/VoenCom';
import SpravkaObObuch from './Desktop/Components/Reports/SpravkaObObuch';
import SpravkaObOkonch from './Desktop/Components/Reports/SpravkaObOkonch';
import TeacherReport from './Desktop/Components/Reports/TeacherReport';
import fetchJSON from "./fetchData";


export default class App extends Component {
  constructor(props) {
    super(props);
    this.id = this.props.id_AVN_User;

    this.state = {
      id_AVN_User: this.props.id_AVN_User,
      user_fio: this.props.user_fio,
      doljnost: this.props.doljnost,
      AVN_BT_report: this.props.AVN_BT_report,
      is_admin: this.props.AVN20,
      selected_menu: 1,
      search_type: 0,
      id_f_educ: 0,
      id_faculty: 0,
      id_rate: 0,
      id_republics: 1,
      id_raion: 0,
      id_oblast: 0,
      id_group: 0,
      id_student: 0,
      startYear: 0,
      endYear: 0,
      id_teacher: 0,
      reportsPage: 0,
      reportType: 0,
      report: '',
      s_t_fio: '',
      language: 0,
      paymentReport: 0,
      applicationType: 0,
      spravka: 0,
      pageStart: 0,
      pageEnd: 0,
      pages: 0,
      total: 0,
      id_okno_zakaz: null,
      DefYear: [],
      DefSem: null,
      YearList: [],
      EducList: [],
      Faculty: [],
      Rate: [],
      Group: [],
      Republics: [],
      OblastList: [],
      RaionList: [],
      StudentList: [],
      StudentListName: [],
      photo: [],
      teacherPhoto: [],
      StudentInf: [],
      Properties: [],
      Description: [],
      GroupByIdRate: [],
      TeachersList: [],
      PropertiesTeacher: [],
      DescriptionTeacher: [],
      ReportsList: [],
      ObhodnoiList: [],
      VoenKom: [],
      PAYMENT: [],
      Studing: [],
      Leave: [],
      TRANSCRIPT: [],
      reportApplicationDone: [],
      reportApplicationWait: [],
      DocumentRegStudentList: [],
      AcademDocList: [],
      AcademDocRegTable: [],
      SpecialList: [],
      DirectionList: [],
      DisciplineList: [],
      Okno_dopolnitelno: [],
      Okno_role: [],
      Okno_role_teacher: [],
      AVN_user_list: [],
      Okno_proporties_list: []
    }
  }
  //----------------------------------componentDidMount----------------------------------------//
  componentDidMount() {
    this.getAcademYear()
    this.postProperties(0)
    this.postPropertiesTeacher(0)
    this.postAccesToProporties(this.state.selected_menu, this.state.id_AVN_User)
    this.getFaculty(this.state.id_AVN_User)
  }
  //----------------------------------AcademYear----------------------------------------//
  getAcademYear = async () => {
    //----------------------------------RatingYears----------------------------------------//
    const json = await fetchJSON('correntyear', this.id, {})
    this.setState({
      CorrYear: json.CorrYear,
      CorrYearfetch: true,
      DefYear: json.CorrYear[0][0].id_a_year,
      DefSem: json.CorrYear[1][0].id_ws
    });
    this.ChangeYear(json.CorrYear[0][0].id_a_year, json.CorrYear[0][0].p32)
  };
  //----------------------------------V_okno_sg_by_Year----------------------------------------//
  postV_okno_sg_by_Year = async (id_a_year, id_faculty) => {
    const json = await fetchJSON('v-okno-sg', this.id, { id_a_year, id_faculty })
    this.setState({
      V_okno_sg_by_Year: json.V_okno_sg,
    });
    if (json) {
      this.postEducName(this.state.id_AVN_User)
    }
  };

  //----------------------------------Faculty----------------------------------------//
  getFaculty = async (id_AVN_User) => {
    const json = await fetchJSON('faculty', this.id, { id_AVN_User })
    this.setState({
      Faculty: json.Faculty[0]
    });
  };
  //----------------------------------EducList----------------------------------------//
  postEducName = async (id_AVN_User) => {
    const json = await fetchJSON('f-educ', this.id, { id_AVN_User })
    if (json) {
      const { V_okno_sg_by_Year } = this.state;
      if (!V_okno_sg_by_Year || V_okno_sg_by_Year === null) return null

      const Filtered_EducList = json.EducList.filter((o1) => {
        return V_okno_sg_by_Year.some((o2) => {
          return o1.id_f_educ == o2.id_f_educ;
        });
      });

      this.setState({
        EducList: Filtered_EducList
      });
      if (this.state.EducList && this.state.EducList !== null && this.state.EducList.length === 1) {
        this.getRate(this.state.EducList[0].id_f_educ)
        this.setState({ id_f_educ: this.state.EducList[0].id_f_educ });
      }
    }
  };
  //----------------------------------Rate----------------------------------------//
  getRate = (id_f_educ) => {
    const { V_okno_sg_by_Year } = this.state;
    if (!V_okno_sg_by_Year || V_okno_sg_by_Year === null) return null

    const Filtered_Rate = V_okno_sg_by_Year.filter(item => item.id_f_educ === id_f_educ);

    const Group_Filtered_Rate = _.chain(Filtered_Rate)
      .groupBy("id_rate")
      .map((value, key) => ({
        id_rate: key,
        p22: value[0].p22,
      }))
      .value()
    setTimeout(() => {
      this.setState({ Rate: Group_Filtered_Rate })
      if (Group_Filtered_Rate && Group_Filtered_Rate !== null && Group_Filtered_Rate.length === 1) {
        this.getGroup(this.state.id_a_year, this.state.id_faculty, this.state.id_f_educ, Group_Filtered_Rate[0].id_rate)
        this.setState({ id_rate: Group_Filtered_Rate[0].id_rate })
      }
    }, 200);

  };

  //----------------------------------Group----------------------------------------//
  getGroup = async (id_year, id_faculty, id_f_educ, id_rate) => {
    const json = await fetchJSON('group', this.id, { id_year, id_faculty, id_f_educ, id_rate })
    this.setState({
      Group: json.Group
    });
    if (json && json.Group.length === 1) {
      this.setState({
        id_group: json.Group[0].id_rate
      })
    }
  };
  //----------------------------------Republic----------------------------------------//
  getRepublics = async () => {
    const json = await fetchJSON('republic', this.id, {})
    this.setState({
      Republics: json.Republics,
    });
  };
  //----------------------------------Oblast----------------------------------------//
  postOblast = async (id_republics) => {
    const json = await fetchJSON('oblast', this.id, { id_republics })
    this.setState({
      OblastList: json.OblastList,
    });
    if (json) {
      setTimeout(() => {
        this.setState({
          startYear: (2000 + (this.state.id_a_year + 1) - (+this.state.id_rate)),
          endYear: ((2000) + (this.state.id_a_year + 1) - (+this.state.id_rate) + 4)
        })
      }, 100);
    }
  };
  //----------------------------------Raion----------------------------------------//
  postRaion = async (id_oblast) => {
    const json = await fetchJSON('raion', this.id, { id_oblast })
    this.setState({
      RaionList: json.RaionList,
      id_raion: json.RaionList && json.RaionList.length ? json.RaionList[0].id_raion : null
    });
    if (json) {
      setTimeout(() => {
        if (this.state.id_raion && this.state.id_raion > 0) {
          this.postVoenKom(
            this.state.id_group,
            this.state.id_student,
            this.state.id_raion,
            this.state.id_faculty,
          )
        }
      }, 120);
    }
  };
  postUpdateRaion = async (index, id_raion, id_oblast, newRaion, newRaionKg) => {
    const json = await fetchJSON('raion-update', this.id, { id_raion, id_oblast, newRaion, newRaionKg })
    if (json) {
      json.result === 1
        ? toast.info(`Район успешно изменен!`) &&
        this.postRaion(this.state.id_oblast)
        : toast.error(`Ошибка в редактировании района!`)
    }
  }
  postInsertRaion = async (id_oblast, newRaion, newRaionKg) => {
    const json = await fetchJSON('raion-insert', this.id, { id_oblast, newRaion, newRaionKg })
    if (json) {
      json.result === 1
        ? toast.info(`Район успешно добавлен!`) &&
        this.postRaion(this.state.id_oblast)
        : toast.error(`Ошибка в добавлении района!`)
    }
  }

  postDeleteRaion = async (id_raion) => {
    const json = await fetchJSON('raion-delete', this.id, { id_raion })
    if (json) {
      json.result === 1
        ? toast.info(`Район успешно удален!`) &&
        this.postRaion(this.state.id_oblast)

        : toast.error(`Ошибка в удалении района!`)
    }
  }

  //----------------------------------StudentList----------------------------------------//
  postStudentList = async (id_a_year, id_f_educ, id_faculty, id_rate, id_group) => {
    const json = await fetchJSON('studentlist', this.id, { id_a_year, id_f_educ, id_faculty, id_rate, id_group })
    if (json) {
      this.setState({
        StudentList: json.StudentList,
      });
      setTimeout(() => {
        if (this.state.StudentList && this.state.StudentList !== null && this.state.StudentList.length > 0) {
          this.SelectStudent(this.state.StudentList[0].id_student, id_group, this.state.StudentList[0].id_protocols, this.state.StudentList[0].id_rate, this.state.StudentList[0].id_faculty)
        }
      }, 10);
    }
  };
  postStudentListName = async (id_AVN_User, SearchNameSt) => {
    const json = await fetchJSON('studentlistName', this.id, { id_AVN_User, SearchNameSt })
    if (json) {
      this.setState({
        StudentListName: json.StudentListName
      });
      setTimeout(() => {
        if (this.state.StudentListName && this.state.StudentListName !== null && this.state.StudentListName.length > 0) {
          this.SelectStudent(this.state.StudentListName[0].id_student, this.state.StudentListName[0].id_group, this.state.StudentListName[0].id_protocols, this.state.StudentListName[0].id_rate, this.state.StudentListName[0].id_faculty)
        }
      }, 20);
    }
  };
  SelectStudent = (id_student, id_group, id_protocols, id_rate, id_faculty) => {
    if (this.state.search_type === 1) {
      this.setState({ id_student, id_group, id_protocols, id_rate, id_faculty })
    }
    else {
      this.setState({ id_student, id_group, id_protocols, id_rate })
    }
    this.postStudentPhoto(id_student, id_group)
    this.postStudentInf(id_student, id_group)
    this.postProperties(id_student)
    this.postDescriptions(id_student)

    setTimeout(() => {
      this.setState({
        newDescription: null,
        id_oblast: 0,
        RaionList: []
      })
    }, 20);

  }
  postStudentPhoto = async (id_student, id_group) => {
    const json = await fetchJSON('base64data', this.id, { id_student, id_group })
    if (json) {
      this.setState({
        photo: json.base64data,
      });
    }
  }
  postStudentInf = async (id_student, id_group) => {
    const json = await fetchJSON('obj', this.id, { id_student, id_group })
    if (json) {
      this.setState({
        StudentInf: json.StudentInf
      });
    }
  }
  postAccesToProporties = async (SotrudnikStudent, id_AVN_User) => {
    const json = await fetchJSON('access_to_proporties', this.id, { SotrudnikStudent, id_AVN_User })
    if (json) {
      this.setState({
        AccesToProporties: json.AccesToProporties
      });
    }
  }
  postProperties = async (id_student) => {
    const json = await fetchJSON('okno-properties', this.id, { id_student })
    if (json) {
      if (this.state.AccesToProporties && this.state.AccesToProporties.length && this.state.selected_menu === 1) {
        setTimeout(() => {
          const { AccesToProporties } = this.state;
          if (!AccesToProporties || AccesToProporties === null) return null
          const Filtered_Properties = json.Properties.reduce((acc, curr) => {
            const index = AccesToProporties.findIndex(item => item.pole === curr.okno_pole);
            curr.visibles = AccesToProporties[index].visibles;

            acc.push(curr);
            return acc;
          }, []);
          this.setState({
            Properties: Filtered_Properties
          });
        }, 100);
      }
      else {
        this.setState({
          Properties: json.Properties
        });
      }
    }
  }
  postPropertiesInsertUpdate = async (ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3) => {
    const id_student = this.state.id_student;
    const id_group = this.state.id_group;
    const json = await fetchJSON('properties-insert-update', this.id, { id_student, id_group, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3 })
    if (json) {
      json.result.length
        ? toast.success(`Запись успешно сохранена!`)
        : toast.error(`Ошибка в сохранении!`)
    }
  }
  postDescriptionInsert = async () => {
    var today = new Date(),
      date = (today.getDate() < 10 ? '0' + today.getDate() : today.getDate()) + '-' + ((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' + today.getFullYear();
    const id_student = this.state.id_student;
    const id_user = this.state.id_AVN_User;
    const okno_description = this.state.user_fio + ', ' + date + ': ' + this.state.newDescription;
    const json = await fetchJSON('description-insert', this.id, { id_student, id_user, okno_description })
    if (json) {
      json.result === 1
        ? toast.success(`Примечание успешно добавлено!`)
        &&
        this.postDescriptions(this.state.id_student)
        : toast.error(`Ошибка в добавлении примечании!`)
      setTimeout(() => {
        this.setState({
          newDescription: null
        })
      }, 20);
    }

  }
  postDescriptionUpdate = async (id_okno_description) => {
    const id_student = this.state.id_student
    const okno_description = this.state.newDescription
    const json = await fetchJSON('description-update', this.id, { id_student, okno_description, id_okno_description })
    if (json) {
      json.result === 1
        ? toast.info(`Примечание успешно изменено!`) &&
        this.postDescriptions(this.state.id_student)
        : toast.error(`Ошибка в редактировании примечании!`)
      setTimeout(() => {
        this.setState({
          newDescription: null
        })
      }, 20);
    }
  }
  postDescriptionDelete = async (id_okno_description) => {
    const json = await fetchJSON('description-delete', this.id, { id_okno_description })
    if (json) {
      json.result === 1
        ? toast.info(`Примечание успешно удалено!`) &&
        this.postDescriptions(this.state.id_student)

        : toast.error(`Ошибка в удалении примечании!`)
    }
  }
  onChangeDescription = (event) => {
    this.setState({ newDescription: event.target.value });
  };
  postDescriptions = async (id_student) => {
    const json = await fetchJSON('okno-description', this.id, { id_student })
    this.setState({
      Description: json.Description
    });
  }
  /*--------------------Student-Reports----------------------------*/
  OpenSpravka = (spravka) => {
    this.setState({ spravka })

    if (spravka === 1) {
      this.getRepublics()
      this.postOblast(1)
      this.postObhodnoiList(this.state.id_group, this.state.id_student, this.state.id_protocols)
    } else {
      this.setState({ id_raion: 0 })
    }
  }
  OpenReportsPage = (reportsPage, reportType, id_student, id_group, id_faculty, id_raion, id_protocols, id_okno_zakaz) => {
    /*--reportType === 1 ---Обходной лист---*/
    /*--reportType === 2 ---Военкомат---*/
    /*--reportType === 3 ---Соцфонд---*/
    if (reportType === 1 && this.state.spravka === 0) {
      this.postObhodnoiList(id_group, id_student, id_protocols)
    }
    if (reportType === 2 && this.state.spravka === 0) {
      this.postVoenKom(id_group, id_student, id_raion, id_faculty)
    }
    if (reportType === 3 && this.state.spravka === 0) {
      this.postObhodnoiList(id_group, id_student, id_protocols)
    }
    if (reportType === 4) {
      this.postStudingReport(id_group, id_student, id_faculty !== undefined ? id_faculty : this.state.id_faculty)
    }
    if (reportType === 5) {
      this.postLeaveReport(id_student)
    }
    if (reportType === 6) {
      window.open(window.location.host + `/?page=Transcript&st=${id_student}&gr=${id_group}`);
    }
    if (reportType == 'teacherReport') {
      this.postTeacherReport(this.state.id_teacher)
    }
    if (this.state.spravka === 0) {
      this.postReportApplicationView(id_okno_zakaz)
    }
    setTimeout(() => {
      this.setState({ reportsPage, reportType })
    }, 100);

  }
  openPaymentReport(paymentReport) {
    this.setState({ paymentReport })
    this.postPayments(this.state.id_student)
  }
  postObhodnoiList = async (id_group, id_student, id_protocols) => {
    const json = await fetchJSON('obhodnoi-list', this.id, { id_group, id_student, id_protocols })
    this.setState({
      ObhodnoiList: json.ObhodnoiList,
    });
  }
  postVoenKom = async (id_group, id_student, id_raion, id_faculty) => {
    const json = await fetchJSON('voenkom', this.id, { id_group, id_student, id_raion, id_faculty })
    this.setState({
      VoenKom: json.VoenKom,
    });
  }
  postPayments = async (id_student) => {
    const json = await fetchJSON('payment', this.id, { id_student })
    this.setState({
      PAYMENT: json.PAYMENT,
    });
  }
  postStudingReport = async (id_group, id_student, id_faculty) => {
    const json = await fetchJSON('studing', this.id, { id_group, id_student, id_faculty })
    this.setState({
      Studing: json.Studing,
    });
  }
  postLeaveReport = async (id_student) => {
    const json = await fetchJSON('leave', this.id, { id_student })
    this.setState({
      Leave: json.Leave,
    });
  }

  selectLanguage = (language) => {
    this.setState({ language })
  }
  //----Select-for-Search-Student------//

  Select_menu = (selected_menu) => {
    this.setState({
      selected_menu, applicationType: 0, reportType: 0
    })
    this.postAccesToProporties(selected_menu, this.state.id_AVN_User)
    setTimeout(() => {
      if (selected_menu === 1) {
        this.setState({ id_teacher: 0 })
        this.SelectTeacher(0, '')
        this.ChangeReportType(0, '')
      } else
        if (selected_menu === 2) {
          this.setState({ StudentListName: [], StudentList: [], search_type: 0, id_student: 0, id_faculty: 0 })
          this.postPropertiesTeacher(0)
          this.getTeacherList()
          this.SelectStudent(0, 0, 0, 0, 0)
          this.postProperties(0)
          this.ChangeReportType(0, '')
        } else if (selected_menu === 3) {
          this.SelectApplicationType(0)
        }
        else if (selected_menu === 4) {
          this.postAcademDocList()
          this.postAcademDocRegTable(0, null)
        }
    }, 30);
    if (selected_menu === 5) {
      this.postOkno_dopolnitelno()
    } else if (selected_menu === 6) {
      this.postOkno_roleList()
      this.postOkno_role_teacherList()
      this.postOkno_proporties_list()
    }

  }
  SelectSearchType = (search_type) => {
    this.setState({ search_type })
    if (search_type === 0) {
      this.setState({
        StudentListName: [],
      })
      this.SelectStudent(0, 0, 0, 0, 0)
    } else {
      setTimeout(() => {
        this.setState({
          StudentList: []
        })
        this.SelectStudent(0, 0, 0, 0, 0)
        // this.postStudentList(this.state.id_a_year, this.state.id_f_educ, this.state.id_faculty, this.state.id_rate, this.state.id_group)
      }, 20);
    }
  }
  ChangeYear = (id_a_year, name) => {
    this.setState({ id_a_year, name });
    if (this.state.id_faculty > 0) {
      this.ChangeFaculty(0, null)
    }
  };
  ChangeFaculty = (id_faculty, faculty_name) => {
    this.setState({ id_faculty, faculty_name });
    this.postV_okno_sg_by_Year(this.state.id_a_year, id_faculty)
    if (this.state.id_f_educ > 0) {
      this.ChangeEduc(0, null)
    }
  }
  ChangeEduc = (id_f_educ, f_educ) => {
    this.setState({ id_f_educ, f_educ });
    if (id_f_educ > 0) {
      this.getRate(id_f_educ)
    }
    if (this.state.id_rate > 0) {
      this.ChangeRate(0)
    }
    // console.log("id_f_educ", id_f_educ)
  };
  ChangeRate = (id_rate) => {
    this.setState({ id_rate });
    if (this.state.Rate && this.state.Rate.length === 1) {
      this.setState({ id_rate: this.state.Rate[0].id_rate });
    }
    if (id_rate > 0) {
      this.getGroup(this.state.id_a_year, this.state.id_faculty, this.state.id_f_educ, id_rate)
    }
    if (this.state.id_group > 0) {
      this.ChangeGroup(0, null)
    }
  }
  ChangeGroup = (id_group, group_name) => {
    this.setState({ id_group, group_name });
    if (id_group > 0 && this.state.Group && this.state.Group !== null) { this.postStudentList(this.state.id_a_year, this.state.id_f_educ, this.state.id_faculty, this.state.id_rate, id_group) }
    // console.log("id_group", id_group)
  }
  SelectRepublic = (e) => {
    this.setState({ id_republics: e.target.value })
    this.postOblast(e.target.value)
  }
  SelectOblast = (e) => {
    this.setState({ id_oblast: e.target.value })
    this.postRaion(e.target.value)
  }
  SelectRaion = (e) => {
    this.setState({ id_raion: e.target.value })
    this.postVoenKom(
      this.state.id_group,
      this.state.id_student,
      e.target.value,
      this.state.id_faculty,
    )
  }
  onChangeStartYear(e) {
    this.setState({ startYear: e.target.value })
  }
  onChangeEndYear(e) {
    this.setState({ endYear: e.target.value })
  }

  //----------------------------------TeachersList----------------------------------------//
  getTeacherList = async () => {
    const json = await fetchJSON('teacher-list', this.id, {})
    this.setState({
      TeachersList: json.TeacherList[0]
    });
  };
  SelectTeacher = (id_teacher, s_t_fio) => {
    this.setState({ id_teacher, s_t_fio })
    this.postTeacherPhoto(id_teacher)
    this.postPropertiesTeacher(id_teacher)
    this.postDescriptionsTeacher(id_teacher)
  }
  postTeacherPhoto = async (id_teacher) => {
    const json = await fetchJSON('teacher-photo', this.id, { id_teacher })
    this.setState({
      teacherPhoto: json.teacherPhoto,
    });
  }
  postPropertiesTeacher = async (id_teacher) => {
    const json = await fetchJSON('okno-properties_teacher', this.id, { id_teacher })
    if (json) {
      if (this.state.AccesToProporties && this.state.AccesToProporties.length && this.state.selected_menu === 2) {
        setTimeout(() => {
          const { AccesToProporties } = this.state;
          if (AccesToProporties && AccesToProporties.length < 0) return null
          if (json.PropertiesTeacher && json.PropertiesTeacher.length < 0) return null
          const Filtered_PropertiesTeacher = json.PropertiesTeacher.reduce((acc, curr) => {
            const index = AccesToProporties.findIndex(item => item.pole === curr.okno_pole);
            curr.visibles = AccesToProporties[index].visibles;

            acc.push(curr);
            return acc;
          }, []);
          this.setState({
            PropertiesTeacher: Filtered_PropertiesTeacher
          });
        }, 20)
      }
      else {
        this.setState({
          PropertiesTeacher: json.PropertiesTeacher
        });
      }
    }
  }
  postTeacherPropertiesInsertUpdate = async (t_fio_pole1, t_fio_pole2, t_fio_pole3, t_fio_pole4, t_fio_pole5, t_fio_pole6, t_fio_pole7, t_fio_pole8, t_fio_pole9) => {
    const id_teacher = this.state.id_teacher
    const AVN_user = this.state.id_AVN_User
    const json = await fetchJSON('teacher-properties-insert-update', this.id, { id_teacher, t_fio_pole1, t_fio_pole2, t_fio_pole3, t_fio_pole4, t_fio_pole5, t_fio_pole6, t_fio_pole7, t_fio_pole8, t_fio_pole9, AVN_user })
    if (json) {
      json.result.length
        ? toast.success(`Запись успешно сохранена!`)
        : toast.error(`Ошибка в сохранении!`)
    }
  }
  postDescriptionTeacherInsert = async () => {
    var today = new Date(),
      date = (today.getDate() < 10 ? '0' + today.getDate() : today.getDate()) + '-' + ((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' + today.getFullYear();
    const id_teacher = this.state.id_teacher
    const id_user = this.state.id_AVN_User
    const okno_description = this.state.user_fio + ', ' + date + ': ' + this.state.newDescriptionTeacher

    const json = await fetchJSON('description-teacher-insert', this.id, { id_teacher, id_user, okno_description })
    if (json) {
      json.result === 1
        ? toast.success(`Примечание успешно добавлено!`)
        &&
        this.postDescriptionsTeacher(this.state.id_teacher)
        : toast.error(`Ошибка в добавлении примечании!`)
          .then(
            this.postDescriptionsTeacher(this.state.id_teacher)
          )
      setTimeout(() => {
        this.setState({
          newDescriptionTeacher: null
        })
      }, 20);
    }
  }
  postDescriptionTeacherUpdate = async (id_okno_description_teacher) => {
    const id_teacher = this.state.id_teacher
    const okno_description = this.state.newDescriptionTeacher
    const json = await fetchJSON('description-teacher-update', this.id, { id_teacher, id_okno_description_teacher, okno_description })
    if (json) {
      json.result === 1
        ? toast.info(`Примечание успешно изменено!`)
        &&
        this.postDescriptionsTeacher(this.state.id_teacher)
        : toast.error(`Ошибка в редактировании примечании!`)
      setTimeout(() => {
        this.setState({
          newDescriptionTeacher: null
        })
      }, 20);
    }
  }
  postDescriptionTeacherDelete = async (id_okno_description_teacher) => {
    const json = await fetchJSON('description-teacher-delete', this.id, { id_okno_description_teacher })
    if (json) {
      json.result === 1
        ? toast.info(`Примечание успешно удалено!`) &&
        this.postDescriptionsTeacher(this.state.id_teacher)
        : toast.error(`Ошибка в удалении примечании!`)
    }
  }
  onChangeDescriptionTeacher = (event) => {
    this.setState({ newDescriptionTeacher: event.target.value });
  };
  postDescriptionsTeacher = async (id_teacher) => {
    const json = await fetchJSON('okno-description-teacher', this.id, { id_teacher })
    this.setState({
      DescriptionTeacher: json.DescriptionTeacher
    });
  }
  postTeacherReport = async (id_teacher) => {
    const json = await fetchJSON('teacher-report', this.id, { id_teacher })
    this.setState({
      TeacherReport: json.TeacherReport,
    });
  }

  ////////////////////////////////DocumentApplication//////////////////////////////////////
  // Applications
  //////////////////////////////////////////////////////////////////////
  postReportList = async () => {
    const json = await fetchJSON('reportslist', this.id, {})
    this.setState({
      ReportsList: json.ReportsList,
    });
  };
  postReportApplicationWait = async (reportType) => {
    const json = await fetchJSON('reportApplicationWait', this.id, { reportType })
    this.setState({
      reportApplicationWait: json.reportApplicationWait.filter(item => item.IsDelete == false)
    })
  }
  postReportApplicationDone = async (s_fio_document) => {
    const json = await fetchJSON('reportApplicationDone', this.id, { s_fio_document })
    this.setState({
      reportApplicationDone: json.reportApplicationDone.filter(item => item.IsDelete == false)
    })
  }
  postReportApplicationView = async (id_okno_zakaz) => {
    await fetchJSON('reportApplicationView', this.id, { id_okno_zakaz })
    setTimeout(() => {
      this.postReportApplicationWait(0)
    }, 20);
  }
  postReportApplicationUpdate = async (status, id_okno_zakaz) => {
    const json = await fetchJSON('reportApplicationUpdate', this.id, { status, id_okno_zakaz })
    if (json) {
      json.result === 1
        ? toast.info(`Запись о выполнении заказа сохранен!`) &&
        this.postDescriptions(this.state.id_student)
        : toast.error(`Ошибка в редактировании записи!`)
      setTimeout(() => {
        this.setState({
          id_okno_zakaz: null
        })
      }, 20);
    }
  }
  SelectApplicationType = (applicationType) => {
    this.setState({ applicationType })
    if (this.state.selected_menu === 3 && applicationType === 0) {
      this.postReportList()
      this.postReportApplicationWait(this.state.reportType)
    } else
      if (this.state.selected_menu === 3 && applicationType === 1) {
        this.postReportApplicationDone()
      }
    if (this.state.selected_menu === 4 && applicationType === 0) {
      this.postAcademDocRegTable(0, null)
      this.setState({
        reportType: 0
      })
    }
    if (this.state.selected_menu === 5 && applicationType === 1) {
      this.postDirectionList(null, 1)
    }
  }
  ChangeReportType = (reportType, report) => {
    this.setState({ reportType, report });
    if (this.state.selected_menu === 3) {
      this.postReportApplicationWait(reportType)
    }
    if (this.state.selected_menu === 4) {
      this.postAcademDocRegTable(reportType, null)
    }
  };
  OnChangeStatusApplication = (e) => {
    this.setState({
      id_okno_zakaz: e.target.value
    })
    this.postReportApplicationUpdate(1, e.target.value)
  }
  /////////////////////////////DocumentRegistr//////////////////////////////////////////////
  postDocumentRegSTlist = async (s_fio_document) => {
    if (s_fio_document && s_fio_document.length > 0) {
      const json = await fetchJSON('searchStudentList', this.id, { s_fio_document })
      this.setState({
        DocumentRegStudentList: json.DocumentRegStudentList,
      });
    } else {
      this.setState({
        DocumentRegStudentList: []
      });
    }
  }
  postAcademDocList = async () => {
    const json = await fetchJSON('academDocList', this.id, {})
    this.setState({
      AcademDocList: json.AcademDocList,
    });
  };
  postAcademDocRegTable = async (reportType, s_fio_document) => {
    const json = await fetchJSON('academDocRegTable', this.id, { reportType, s_fio_document })
    this.setState({
      AcademDocRegTable: json.AcademDocRegTable,
    });
  };
  postAcademDocRegTableUpdate = async (selected_id_student, id_academ_document_type, new_uni_number, new_reg_number, give_date, id_akadem_document) => {
    const json = await fetchJSON('academDocRegTableUpdate', this.id, { selected_id_student, id_academ_document_type, new_uni_number, new_reg_number, give_date, id_akadem_document })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно изменена!`) &&
        this.postAcademDocRegTable(this.state.reportType, null)
        : toast.error(`Ошибка в редактировании записи!`)
    }
  }
  postacAdemDocRegTableInsert = async (selected_id_student, id_academ_document_type, new_uni_number, new_reg_number, give_date, id_AVN_User) => {
    const json = await fetchJSON('academDocRegTableInsert', this.id, { selected_id_student, id_academ_document_type, new_uni_number, new_reg_number, give_date, id_AVN_User })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно добавлена!`) &&
        this.postAcademDocRegTable(this.state.reportType, null)
        : toast.error(`Ошибка в добавлении записи!`)
    }
  }
  postacAdemDocRegTableDelete = async (id_academ_document) => {
    const json = await fetchJSON('academDocRegTableDelete', this.id, { id_academ_document })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно удалена!`) &&
        this.postAcademDocRegTable(this.state.reportType, null)

        : toast.error(`Ошибка в удалении записи!`)
    }
  }
  /////////////////////////////AcademReff___Settings//////////////////////////////////////////////
  postOkno_dopolnitelno = async () => {
    const json = await fetchJSON('Okno_dopolnitelno', this.id, {})
    this.setState({
      Okno_dopolnitelno: json.Okno_dopolnitelno && json.Okno_dopolnitelno[0],
    });
  };
  postOkno_dopolnitelnoUpdate = async (insert_pole, insert_pole_kg, id_okno_dopolnitelno) => {
    const json = await fetchJSON('Okno_dopolnitelno-update', this.id, { insert_pole, insert_pole_kg, id_okno_dopolnitelno })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно изменена!`) &&
        this.postOkno_dopolnitelno()
        : toast.error(`Ошибка в редактировании записи!`)
    }
  }

  postSpecialList = async (search_special, pageNum) => {
    const json = await fetchJSON('special', this.id, { search_special, pageNum })
    this.setState({
      SpecialList: json.SpecialList && json.SpecialList[0],
      pageStart: json.SpecialList && json.SpecialList[0] && json.SpecialList[0][0].pageStart ? json.SpecialList[0][0].pageStart : 0,
      pageEnd: json.SpecialList && json.SpecialList[0] && json.SpecialList[0][0].pageEnd ? json.SpecialList[0][0].pageEnd : 0,
      pages: json.SpecialList && json.SpecialList[0] && json.SpecialList[0][0].pages ? json.SpecialList[0][0].pages : 0,
      total: json.SpecialList && json.SpecialList[0] && json.SpecialList[0][0].total ? json.SpecialList[0][0].total : 0
    });
  };
  postSpecialUpdate = async (id_AVN_User, setAcademKG, setAcademEN, id_special, search_special, pageNum) => {
    const json = await fetchJSON('special-update', this.id, { id_AVN_User, setAcademKG, setAcademEN, id_special })
    if (json) {
      json.result === 1
        ? toast.info(`Специальность успешно изменена!`) &&
        this.postSpecialList(search_special, pageNum)
        : toast.error(`Ошибка в редактировании cпециальности!`)
    }
  }

  postDirectionList = async (search_direction, pageNum) => {
    const json = await fetchJSON('direction', this.id, { search_direction, pageNum })
    this.setState({
      DirectionList: json.DirectionList && json.DirectionList[0],
      pageStart: json.DirectionList && json.DirectionList[0] && json.DirectionList[0][0].pageStart ? json.DirectionList[0][0].pageStart : 0,
      pageEnd: json.DirectionList && json.DirectionList[0] && json.DirectionList[0][0].pageEnd ? json.DirectionList[0][0].pageEnd : 0,
      pages: json.DirectionList && json.DirectionList[0] && json.DirectionList[0][0].pages ? json.DirectionList[0][0].pages : 0,
      total: json.DirectionList && json.DirectionList[0] && json.DirectionList[0][0].total ? json.DirectionList[0][0].total : 0
    });
  };
  postDirectionUpdate = async (id_AVN_User, setAcademKG, setAcademEN, id_direction, search_direction, pageNum) => {
    const json = await fetchJSON('direction-update', this.id, { id_AVN_User, setAcademKG, setAcademEN, id_direction })
    if (json) {
      json.result === 1
        ? toast.info(`Направление успешно изменено!`) &&
        this.postDirectionList(search_direction, pageNum)
        : toast.error(`Ошибка в редактировании направлении!`)
    }
  }

  postDisciplineList = async (search_discipline, pageNum) => {
    const json = await fetchJSON('discipline', this.id, { search_discipline, pageNum })
    this.setState({
      DisciplineList: json.DisciplineList && json.DisciplineList[0],
      pageStart: json.DisciplineList && json.DisciplineList[0] && json.DisciplineList[0][0].pageStart ? json.DisciplineList[0][0].pageStart : 0,
      pageEnd: json.DisciplineList && json.DisciplineList[0] && json.DisciplineList[0][0].pageEnd ? json.DisciplineList[0][0].pageEnd : 0,
      pages: json.DisciplineList && json.DisciplineList[0] && json.DisciplineList[0][0].pages ? json.DisciplineList[0][0].pages : 0,
      total: json.DisciplineList && json.DisciplineList[0] && json.DisciplineList[0][0].total ? json.DisciplineList[0][0].total : 0
    });
  };
  postDisciplineUpdate = async (id_AVN_User, setAcademKG, setAcademEN, id_discipline, search_discipline, pageNum) => {
    const json = await fetchJSON('discipline-update', this.id, { id_AVN_User, setAcademKG, setAcademEN, id_discipline })
    if (json) {
      json.result === 1
        ? toast.info(`Дисциплина успешно изменена!`) &&
        this.postDisciplineList(search_discipline, pageNum)
        : toast.error(`Ошибка в редактировании дисциплины!`)
    }
  }

  /////////////////////////////Okno_role___Settings//////////////////////////////////////////////

  postOkno_roleList = async () => {
    const json = await fetchJSON('okno_role', this.id, {})
    this.setState({
      Okno_role: json.Okno_role && json.Okno_role[0]
    });
  };
  postUserList = async (userName) => {
    const json = await fetchJSON('avn_users', this.id, { userName })
    this.setState({
      AVN_user_list: json.AVN_user_list && json.AVN_user_list[0]
    });
  };
  postOkno_role_teacherList = async () => {
    const json = await fetchJSON('okno_role_teacher', this.id, {})
    this.setState({
      Okno_role_teacher: json.Okno_role_teacher && json.Okno_role_teacher[0]
    });
  };
  //---------------------OknoRole____Insert---------------------//

  postOknoRoleInsert = async (id_teacher, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3) => {
    const json = await fetchJSON('okno_role_insert', this.id, { id_teacher, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3 })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно добавлена!`) &&
        this.postOkno_roleList()
        : toast.error(`Ошибка в добавлении записи!`)
    }
  }
  postOknoRoleUpdate = async (ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3, id_role_okno) => {
    const json = await fetchJSON('okno_role_update', this.id, { ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3, id_role_okno })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно изменена!`) &&
        this.postOkno_roleList()
        : toast.error(`Ошибка в редактировании записи!`)
    }
  }
  postOknoRoleDelete = async (id_role_okno) => {
    const json = await fetchJSON('okno_role_delete', this.id, { id_role_okno })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно удалена!`) &&
        this.postOkno_roleList()
        : toast.error(`Ошибка в удалении записи!`)
    }
  }
  //---------------------OknoRoleSotrudnik____Insert---------------------//

  postOknoRoleSotrudnikInsert = async (id_teacher, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3) => {
    const json = await fetchJSON('okno_role_sotrudnik_insert', this.id, { id_teacher, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3 })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно добавлена!`) &&
        this.postOkno_role_teacherList()
        : toast.error(`Ошибка в добавлении записи!`)
    }
  }
  postOknoRoleSotrudnikUpdate = async (ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3, id_role_okno) => {
    const json = await fetchJSON('okno_role_sotrudnik_update', this.id, { ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3, id_role_okno })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно изменена!`) &&
        this.postOkno_role_teacherList()
        : toast.error(`Ошибка в редактировании записи!`)
    }
  }
  postOknoRoleSotrudnikDelete = async (id_role_okno) => {
    const json = await fetchJSON('okno_role_sotrudnik_delete', this.id, { id_role_okno })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно удалена!`) &&
        this.postOkno_role_teacherList()
        : toast.error(`Ошибка в удалении записи!`)
    }
  }

  postOkno_proporties_list = async () => {
    const json = await fetchJSON('okno_proporties_list', this.id, {})
    this.setState({
      Okno_proporties_list: json.Okno_proporties_list && json.Okno_proporties_list[0]
    });
  };

  postOkno_proporties_list_Update = async (okno_title, Description, visibility, id_okno_properties) => {
    const json = await fetchJSON('okno_proporties_update', this.id, { okno_title, Description, visibility, id_okno_properties })
    if (json) {
      json.result === 1
        ? toast.info(`Запись успешно изменена!`) &&
        this.postOkno_proporties_list() &&
        this.postProperties(0) &&
        this.postOkno_role_teacherList() &&
        this.postOkno_roleList()
        : toast.error(`Ошибка в редактировании записи!`)
    }
  }




  render() {
    const {
      DefYear,
      DefSem,
      EducList,
      Faculty,
      Rate,
      Group,
      StudentList,
      StudentListName,
      photo,
      StudentInf,
      Properties,
      AccesToProporties,
      Description,
      Republics,
      OblastList,
      RaionList,
      TeachersList,
      teacherPhoto,
      PropertiesTeacher,
      DescriptionTeacher,
      ReportsList,
      ObhodnoiList,
      VoenKom,
      PAYMENT,
      Studing,
      Leave,
      TRANSCRIPT,
      reportApplicationDone,
      reportApplicationWait,
      DocumentRegStudentList,
      AcademDocList,
      AcademDocRegTable,
      DisciplineList,
      SpecialList,
      DirectionList,
      Okno_dopolnitelno,
      Okno_role,
      AVN_user_list,
      Okno_role_teacher,
      Okno_proporties_list
    } = this.state
    if (
      DefYear && DefYear === null &&
      DefSem && DefSem === null &&
      YearList && YearList === null &&
      Faculty && Faculty === null &&
      StudentList && StudentList === null &&
      StudentListName && StudentListName === null &&
      EducList && EducList === null &&
      Group && Group === null &&
      Rate && Rate === null &&
      photo && photo === null &&
      StudentInf && StudentInf === null &&
      Properties && Properties === null &&
      AccesToProporties && AccesToProporties === null &&
      Description && Description === null &&
      OblastList && OblastList === null &&
      Republics && Republics === null &&
      RaionList && RaionList === null &&
      TeachersList && TeachersList === null &&
      teacherPhoto && teacherPhoto === null &&
      PropertiesTeacher && PropertiesTeacher === null &&
      DescriptionTeacher && DescriptionTeacher === null &&
      ReportsList && ReportsList === null &&
      ObhodnoiList && ObhodnoiList === null &&
      VoenKom && VoenKom === null &&
      PAYMENT && PAYMENT === null &&
      Studing && Studing === null &&
      Leave && Leave === null &&
      TRANSCRIPT && TRANSCRIPT === null &&
      reportApplicationDone && reportApplicationDone === null &&
      reportApplicationWait && reportApplicationWait === null &&
      DocumentRegStudentList && DocumentRegStudentList === null &&
      AcademDocList && AcademDocList === null &&
      AcademDocRegTable && AcademDocRegTable === null &&
      DisciplineList && DisciplineList === null &&
      SpecialList && SpecialList === null &&
      DirectionList && DirectionList === null &&
      Okno_dopolnitelno && Okno_dopolnitelno === null &&
      Okno_role && Okno_role === null &&
      Okno_role_teacher && Okno_role_teacher === null &&
      AVN_user_list && AVN_user_list === null &&
      Okno_proporties_list && Okno_proporties_list === null
    ) return null;

    else {
      if (StudentList) {
        return (
          <div className="App">
            <ToastContainer autoClose={5000} position="bottom-left" />
            <Dmain
              {...this.state}
              postLogout={this.props.postLogout}
              postPropertiesInsertUpdate={this.postPropertiesInsertUpdate.bind(this)}
              Select_menu={this.Select_menu.bind(this)}
              SelectSearchType={this.SelectSearchType.bind(this)}
              ChangeYear={this.ChangeYear.bind(this)}
              ChangeEduc={this.ChangeEduc.bind(this)}
              ChangeFaculty={this.ChangeFaculty.bind(this)}
              ChangeRate={this.ChangeRate.bind(this)}
              ChangeGroup={this.ChangeGroup.bind(this)}
              SelectStudent={this.SelectStudent.bind(this)}
              postStudentListName={this.postStudentListName.bind(this)}
              onChangeDescription={this.onChangeDescription.bind(this)}
              postDescriptionInsert={this.postDescriptionInsert.bind(this)}
              postDescriptionUpdate={this.postDescriptionUpdate.bind(this)}
              postDescriptionDelete={this.postDescriptionDelete.bind(this)}
              SelectRepublic={this.SelectRepublic.bind(this)}
              SelectOblast={this.SelectOblast.bind(this)}
              SelectRaion={this.SelectRaion.bind(this)}
              onChangeStartYear={this.onChangeStartYear.bind(this)}
              onChangeEndYear={this.onChangeEndYear.bind(this)}
              SelectTeacher={this.SelectTeacher.bind(this)}
              postTeacherPropertiesInsertUpdate={this.postTeacherPropertiesInsertUpdate.bind(this)}
              postDescriptionTeacherInsert={this.postDescriptionTeacherInsert.bind(this)}
              onChangeDescriptionTeacher={this.onChangeDescriptionTeacher.bind(this)}
              postDescriptionTeacherUpdate={this.postDescriptionTeacherUpdate.bind(this)}
              postDescriptionTeacherDelete={this.postDescriptionTeacherDelete.bind(this)}
              postObhodnoiList={this.postObhodnoiList.bind(this)}
              OpenReportsPage={this.OpenReportsPage.bind(this)}
              openPaymentReport={this.openPaymentReport.bind(this)}
              postUpdateRaion={this.postUpdateRaion.bind(this)}
              postInsertRaion={this.postInsertRaion.bind(this)}
              postDeleteRaion={this.postDeleteRaion.bind(this)}
              SelectApplicationType={this.SelectApplicationType.bind(this)}
              ChangeReportType={this.ChangeReportType.bind(this)}
              OnChangeStatusApplication={this.OnChangeStatusApplication.bind(this)}
              postReportApplicationDone={this.postReportApplicationDone.bind(this)}
              OpenSpravka={this.OpenSpravka.bind(this)}
              postDocumentRegSTlist={this.postDocumentRegSTlist.bind(this)}
              postAcademDocRegTable={this.postAcademDocRegTable.bind(this)}
              postacAdemDocRegTableInsert={this.postacAdemDocRegTableInsert.bind(this)}
              postAcademDocRegTableUpdate={this.postAcademDocRegTableUpdate.bind(this)}
              postacAdemDocRegTableDelete={this.postacAdemDocRegTableDelete.bind(this)}
              postSpecialList={this.postSpecialList.bind(this)}
              postSpecialUpdate={this.postSpecialUpdate.bind(this)}
              postDirectionList={this.postDirectionList.bind(this)}
              postDirectionUpdate={this.postDirectionUpdate.bind(this)}
              postDisciplineList={this.postDisciplineList.bind(this)}
              postDisciplineUpdate={this.postDisciplineUpdate.bind(this)}
              postOkno_dopolnitelnoUpdate={this.postOkno_dopolnitelnoUpdate.bind(this)}
              postOknoRoleInsert={this.postOknoRoleInsert.bind(this)}
              postOknoRoleUpdate={this.postOknoRoleUpdate.bind(this)}
              postOknoRoleDelete={this.postOknoRoleDelete.bind(this)}
              postOknoRoleSotrudnikInsert={this.postOknoRoleSotrudnikInsert.bind(this)}
              postOknoRoleSotrudnikUpdate={this.postOknoRoleSotrudnikUpdate.bind(this)}
              postOknoRoleSotrudnikDelete={this.postOknoRoleSotrudnikDelete.bind(this)}
              postUserList={this.postUserList.bind(this)}
              postOkno_proporties_list_Update={this.postOkno_proporties_list_Update.bind(this)}
            />
            {this.state.reportsPage === 1 ?
              <div className='ReportsPage' style={{ position: 'absolute' }}>
                {this.state.reportType === 1 ?
                  <Obhodnoilist
                    ObhodnoiList={ObhodnoiList}
                    OpenReportsPage={this.OpenReportsPage.bind(this)}
                    selectLanguage={this.selectLanguage.bind(this)}
                    language={this.state.language}
                  />
                  : this.state.reportType === 2 ?
                    <VoenCom
                      {...this.state}
                      OpenReportsPage={this.OpenReportsPage.bind(this)}
                      selectLanguage={this.selectLanguage.bind(this)}
                      language={this.state.language} />
                    : this.state.reportType === 3 ?
                      <SocFond
                        {...this.state}
                        OpenReportsPage={this.OpenReportsPage.bind(this)}
                        selectLanguage={this.selectLanguage.bind(this)} /> :
                      this.state.reportType === 4 ?
                        <SpravkaObObuch
                          {...this.state}
                          OpenReportsPage={this.OpenReportsPage.bind(this)}
                          selectLanguage={this.selectLanguage.bind(this)} /> :
                        this.state.reportType === 5 ?
                          <SpravkaObOkonch
                            {...this.state}
                            OpenReportsPage={this.OpenReportsPage.bind(this)}
                            selectLanguage={this.selectLanguage.bind(this)} /> :
                          this.state.reportType === 'teacherReport' ?
                            <TeacherReport
                              {...this.state}
                              OpenReportsPage={this.OpenReportsPage.bind(this)}
                              selectLanguage={this.selectLanguage.bind(this)}
                            /> : null
                }
              </div> : null}

          </div>
        )
      }
    }
  }
}

